<div class="flex justify-center">
  <div
    [class]="
      'flex justify-center items-center p-lg rounded-full mb-xl ' +
      iconBackgroundClass
    ">
    @if (type() === 'restore') {
      <lib-restore-icon [iconClass]="'size-8 text-primary-500'" />
    }

    @if (type() === 'archive') {
      <lib-archive-icon [iconClass]="'size-8 text-destructive-500'" />
    }
  </div>
</div>

<p class="text-lg text-center font-medium mb-sm text-neutral-900">
  {{ titleKey() | transloco }}
</p>

<p class="text-sm text-neutral-500 text-center mb-4xl">
  {{ descriptionKey() | transloco }}

  @if (highlightedDescriptionKey()) {
    <span [class]="'font-medium block ' + highlightedTextClass">
      {{ highlightedDescriptionKey() | transloco }}
    </span>
  }
</p>

<div class="flex flex-col gap-md text-base font-medium">
  <button
    (click)="onConfirm()"
    [class.opacity-30]="isLoading()"
    [disabled]="isLoading()"
    [class]="
      'py-sm rounded-md text-white text-base cursor-pointer ' +
      confirmButtonClass
    ">
    {{ confirmButtonKey() | transloco }}
  </button>

  <button
    (click)="onClose()"
    class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
    {{ cancelButtonKey() | transloco }}
  </button>
</div>
